/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import InsightHeader from "./InsightHeader/InsightHeader";
import { Row } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  clearReportDataFormSate,
  clearReports,
  clearState,
  insightsSelector,
} from "../../../../redux/reducers/insights/insightsReducer";
import { ReportColumnData, ReportData } from "../../../models/insights/reports";
import moment from "moment-timezone";
import "./InsightHeader/insightHeader.less";
import {
  DefaultTime,
  DurationDropDownConstants,
  FrequencyDropdown,
  InsightRepresentation,
  TimePattern,
  jsonData,
  newAmountEnteredGraph,
  reportTypes,
  DefaultDropDownConstants,
} from "../../../constants/constants";
import InsightGraph from "./insightGraph";
import InsightTable, { PaymentDetailTable } from "./insightTable";
import { Serie } from "@nivo/line";
import {
  convertForGraphData,
  daysDifference,
  getCoumnsKeys,
  getHighestFrequency,
} from "../../../../utility/insightUtils";
import { fetchOrganisationbyID } from "../../../../redux/actions/organisation/fetchOrganisationDetails";
import { userStateSelector } from "../../../../redux/reducers/user/userReducer";
import {
  cameFromOrganisation,
  getClientTimeZoneOffset,
  getFormattedDate,
  translateGraphText
} from "../../../../utility/appUtil";
import { appSelector } from "../../../../redux/reducers/app/appReducers";
import { ReportScreen } from "./insights.styles";
import AntdPagination from "../../stateless/common/pagination/pagination";
import { organisationDetailsSelector } from "../../../../redux/reducers/organisation/organisationDetailsReducer";
import { useTranslation } from "react-i18next";
import { UseGAEventTracker } from "../../../../utility/useGAEventTracker";
import { AppService } from "../../../services/ui/appService";

const Insights = (props: any) => {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const graphRef = useRef<any>();
  const {
    reportData,
    prevReport,
    reportValues,
    reportDataFormState,
    formState,
    viewDataValues,
  } = useSelector(insightsSelector);
  const location: any = useLocation();
  const { appUser } = useSelector(userStateSelector);
  const { selectedOrganisation } = useSelector(appSelector);
  const { organisation} = useSelector(organisationDetailsSelector)
  const [startTime, setStartTime] = useState(DefaultTime.START);
  const [endTime, setEndTime] = useState(DefaultTime.END);
  const [chartData, setChartData] = useState<any>([]);
  const chartTimeFormat = "YYYY-MM-DD " + TimePattern.HH_MM;
  const [insightHeaderHeight, setInsightHeaderHeight] = useState(64);
  const [activeRepresentation, setActiveRepresentation] = useState<any>(
    InsightRepresentation.TABULAR
  );
  const [groupByValue, setGroupByValue] = useState<boolean>(false);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [onlyCloudCheck, setOnlyCloudCheck] = useState<boolean>(false);
  const [pageChanged, setPageChanged] = useState<boolean>(false);
  const [pages, setPages] = useState(0);
  const [startPage, setStartPage] = useState(moment().format(chartTimeFormat));
  const [endPage, setEndPage] = useState(moment().format(chartTimeFormat));
  const [currentPage, setCurrentPage] = useState(1);
  const [exportData, setExportData] = useState<boolean>(false);
  const [breakFrom, setBreakFrom] = useState(null);
  const [breakTo, setBreakTo] = useState(null);
  const [downloadingGraph, setDownloadingGraph] = useState<boolean>(false)
  const [reportViewValue, setReportViewValue] = useState<any>("");
  const [locations, setLocations] = useState([]);
  const [devices, setDevices] = useState([]);
  const [startDateTime, setStartDateTime] = useState();
  const [endDateTime, setEndDateTime] = useState();
  const [selectedFrequency, setSelectedFrequency] = useState("day");
  const [insighthasData, setInsightHasData] = useState<boolean>(true)
  const [inisghtReportValue, setInisghtReportValue] = useState<boolean>(false)
  const [CompareFiltering, setCompareFiltering] = useState<any>(DefaultDropDownConstants.DEFAULT_VALUE)
  const [selectedReports, setSelectedMultipleReports] = useState<any>([])
  const [selectedTimeFrames, setSelectedTimeFrames] = useState<any>([])
  const [compareReportsLoading, setCompareReportsLoading] = useState(false)
  const [compareStartDateTime, setCompareStartDateTime] = useState();
  const [compareEndDateTime, setCompareEndDateTime] = useState();
  const [compareFrequency, setCompareFrequency] = useState();
  const [compareGroupByValue, setCompareGroupByValue] = useState();

  const getOrgId = () => {
    let orgId = appUser?.organization.id as string;
    if (cameFromOrganisation()) {
      orgId = selectedOrganisation?.id;
    }
    return orgId;
  };
  useEffect(() => {
    if (location?.state?.Viewable || location?.state?.editable) {
      setActiveRepresentation(
        viewDataValues?.filters?.dataRepresentation
          ? viewDataValues?.filters?.dataRepresentation
          : InsightRepresentation.TABULAR
      );
    }
  }, [viewDataValues]);

  useEffect(() => {
    if (activeRepresentation === InsightRepresentation.GRAPHICAL ) {
      UseGAEventTracker("Insights Category", "insight graph view", `Selected insight ${activeRepresentation}`);
    }else{
      UseGAEventTracker("Insights Category", "insight table view", `Selected insight ${activeRepresentation}`);
    }
  }, [activeRepresentation]);

  useEffect(() => {
    dispatch(fetchOrganisationbyID(getOrgId()));
    return () => {
      dispatch(clearReports());
      dispatch(clearReportDataFormSate());
      dispatch(clearState());
    };
  }, []);

  useEffect(() => {
    setOnlyCloudCheck(organisation?.result?.onlyCloudCheck)
  }, [organisation])
  
  // selectors for reports
  const [format, setFormat] = useState<{
    x?: {
      format: any;
      scale: {
        precision: any;
        format: any;
        tickValue: any;
        min?: any;
        max?: any;
      };
    };
    y?: {};
  }>({});

  const getTickInterval = () => {
    let days: number;
    if (groupByValue) {
      days = daysDifference(startDateTime, endDateTime);
      switch (reportData?.interval) {
        case "hour":
          if (days <= 0.3) {
            return "hour";
          } else {
            return "3 hours";
          }
        case "day":
          return "day";
        default:
          return "month";
      }
    } else {
      let highestfrequency: any = getHighestFrequency(
        startDateTime,
        endDateTime
      );

      if (highestfrequency == selectedFrequency) {
        days = daysDifference(startDateTime, endDateTime);
        switch (true) {
          case days <= 0.3:
            return "hour";
          case days <= 1:
            return "3 hours";
          case days <= 7:
            return "day";
          case days <= 31:
            return "3 days";
          default:
            return "month";
        }
      } else if (
        reportValues?.filterDuration ==
          DurationDropDownConstants.CUSTOM_VALUE &&
        selectedFrequency === FrequencyDropdown.DAY_VALUE
      ) {
        let actualDifference = daysDifference(startDateTime, endDateTime);
        switch (true) {
          case actualDifference <= 0.3:
            return "hour";
          case actualDifference <= 1:
            return "3 hours";
          case actualDifference <= 7:
            return "day";
          case actualDifference <= 30:
            return "3 days";
          case actualDifference >= 31:
            return "3 days";
          default:
            return "month";
        }
      } else {
        days = daysDifference(startPage, endPage);
        switch (true) {
          case days <= 0.3:
            return "hour";
          case days <= 1:
            return "3 hours";
          case days <= 7:
            return "day";
          case days <= 31:
            return "3 days";
          default:
            return "month";
        }
      }
    }
  };



  const getGraphData = () => {
    let graphData = [];
    setCompareReportsLoading(true)
    if (reportData && reportData.rows) {
      graphData = extractData(reportData);
    }
    setCompareReportsLoading(false)

    return graphData;
  };

  interface ChartData {
    data: Serie[];
    header: string;
  }

  const setGraphHeader = () => {
    if (groupByValue) {
      return "";
    }
    switch (reportData.interval) {
      case "hour":
        return getFormattedDate(startPage, "Do MMMM YYYY");
      case "day":
        if (
          getFormattedDate(startPage, "YYYY") !==
          getFormattedDate(endPage, "YYYY")
        ) {
          return (
            getFormattedDate(startPage, "MMMM YYYY") +
            " - " +
            getFormattedDate(endPage, "MMMM YYYY")
          );
        } else if (
          getFormattedDate(startPage, "MMMM") !==
          getFormattedDate(endPage, "MMMM")
        ) {
          return (
            getFormattedDate(startPage, "MMMM") +
            " - " +
            getFormattedDate(endPage, "MMMM YYYY")
          );
        } else if (
          getFormattedDate(startPage, "D") == getFormattedDate(endPage, "D")
        ) {
          return getFormattedDate(startPage, "Do MMMM YYYY");
        }
        return (
          getFormattedDate(startPage, "Do") +
          " - " +
          getFormattedDate(endPage, "Do MMMM YYYY")
        );
      case "month":
        if (
          getFormattedDate(startPage, "YYYY") !==
          getFormattedDate(endPage, "YYYY")
        ) {
          return (
            getFormattedDate(startPage, "MMMM YYYY") +
            " - " +
            getFormattedDate(endPage, "MMMM YYYY")
          );
        } else if (
          getFormattedDate(startPage, "MMMM") !==
          getFormattedDate(endPage, "MMMM")
        ) {
          return (
            getFormattedDate(startPage, "MMMM") +
            " - " +
            getFormattedDate(endPage, "MMMM YYYY")
          );
        }
        return getFormattedDate(startPage, "MMMM YYYY");
      default:
        return "";
    }
  };

  const getInsightsDateLabels = (date, format) => {
    let offset;
    if (groupByValue) {
      offset = getClientTimeZoneOffset(startDateTime);
    } else {
      offset = getClientTimeZoneOffset(startPage);
    }
    return moment(date).utcOffset(offset).format(format);
  };

  const compareTimeSetGraphHeader = () => {
    if (groupByValue) {
      return "";
    }
    console.log("compareFrequency", compareFrequency)
    switch (compareFrequency) {
      case "hour":
        console.log("compareStartDateTime", compareStartDateTime)
        return getFormattedDate(compareStartDateTime, "Do MMMM YYYY");
      case "day":
        if (
          getFormattedDate(compareStartDateTime, "YYYY") !==
          getFormattedDate(compareEndDateTime, "YYYY")
        ) {
          return (
            getFormattedDate(compareStartDateTime, "MMMM YYYY") +
            " - " +
            getFormattedDate(compareEndDateTime, "MMMM YYYY")
          );
        } else if (
          getFormattedDate(compareStartDateTime, "MMMM") !==
          getFormattedDate(compareEndDateTime, "MMMM")
        ) {
          return (
            getFormattedDate(compareStartDateTime, "MMMM") +
            " - " +
            getFormattedDate(compareEndDateTime, "MMMM YYYY")
          );
        } else if (
          getFormattedDate(compareStartDateTime, "D") == getFormattedDate(compareEndDateTime, "D")
        ) {
          return getFormattedDate(compareStartDateTime, "Do MMMM YYYY");
        }
        return (
          getFormattedDate(compareStartDateTime, "Do") +
          " - " +
          getFormattedDate(compareEndDateTime, "Do MMMM YYYY")
        );
      case "month":
        if (
          getFormattedDate(compareStartDateTime, "YYYY") !==
          getFormattedDate(compareEndDateTime, "YYYY")
        ) {
          return (
              getFormattedDate(compareStartDateTime, "MMMM YYYY") +
            " - " +
            getFormattedDate(compareEndDateTime, "MMMM YYYY")
          );
        } else if (
          getFormattedDate(compareStartDateTime, "MMMM") !==
          getFormattedDate(compareEndDateTime, "MMMM")
        ) {
          return (
            getFormattedDate(compareStartDateTime, "MMMM") +
            " - " +
            getFormattedDate(compareEndDateTime, "MMMM YYYY")
          );
        }
        return getFormattedDate(compareStartDateTime, "MMMM YYYY");
      default:
        return "";
    }
  };


  function processGraphData(mainGraphData, compareGraphData,mainGraphDataId,SecondaryGraphDataId) {
    // Define random colors array
    const randomColors = [
        '#2196f3', // blue
        '#ff9800', // orange
        '#4caf50', // green
        '#f44336', // red
        '#9c27b0', // purple
        '#795548', // brown
        '#e91e63', // pink
        '#607d8b', // gray
        '#cddc39', // lime
        '#00bcd4'  // cyan
    ];

    if(SecondaryGraphDataId === 7) {
      console.log(compareGraphData)
      compareGraphData = compareGraphData.filter(item => {
        // Keep only the object with "Totals" in the header
        return item.header.includes('Totals');
    })
    }

    // Step 1: Filter out items with id 'Failed' from mainGraphData
    mainGraphData.forEach(section => {
        section.data = section.data.filter(item => item.id !== 'Failed');
        
        // Assign unique colors to each data item in the section
        section.data.forEach((value, index) => {
            value.color = randomColors[index % randomColors.length];
        });
    });
 
    // Step 2: Update id and ogId based on header in mainGraphData
    console.log("----------------------------------------- Data before update -----------------------------------------");
    mainGraphData.forEach(item => {

        console.log("Item Header: ", item.header);
        let headerValue = item.header.split(":")[0]?.trim();
        if(item.header.includes(":")) {
          item.header = t(DefaultDropDownConstants.TYPE_TEXT) + ": " + item.header.split(":")[1]?.trim();
        }else{
          item.header = t(DefaultDropDownConstants.TYPE_TEXT);
        }
        item.data.forEach(value => {
            if(value.id === 'People Out' || value.id === 'People In') {
                value.id = value.id;
                value.ogId = value.id;
            }  else {
                value.id = headerValue;
                value.ogId = headerValue;
            }
            // Color is already assigned above
        });
    });
    console.log("----------------------------------------- Data after update -----------------------------------------");
 
    // Step 3: Update and push items from compareGraphData to mainGraphData
    if (compareGraphData) {
        compareGraphData.forEach(item => {
            let headerValue = item.header.split(":")[0].trim();
            item.header = t(DefaultDropDownConstants.TYPE_TEXT);
            // console.log(headerValue)
            item.data.forEach((value, index) => {
                if (value.id === 'Successful' || value.id === 'Success'||  value.id === 'Amount Entered') {
                    value.id = headerValue;
                    value.ogId = headerValue;
                    value.color = randomColors[index % randomColors.length];
                }
                // Step 4: Push to mainGraphData if id is not 'Failed'
                // console.log(value.id)
                if (value.id !== 'Failed') {
                    mainGraphData.forEach(section => {
                        // Create a new object with a unique color when pushing
                        section.data.push({
                            ...value,
                            color: randomColors[index % randomColors.length]
                        });
                    });
                }
            });
        });
    }
 
    return mainGraphData;
  };

  function processCompareTypeData(data: ReportData) {
    let graphData: ChartData[] = [];
    let graphs: {[key: string]: ReportColumnData[]} = {};

    if (reportViewValue === reportTypes.sorting) {
      for (let row of data.rows) {
        for (let loc of row.location) {
          if (loc?.isAMHLocation) {
            data.columns.map((col) => {
              let newCol = {...col}
              const newHeader = `${loc.locationName}.${col.header}`;
              newCol.prevId = newCol.id;
              newCol.id = newHeader;
              newCol.header = newHeader;
              graphs = {...graphs, [newHeader]: [newCol]};
            });
          }
        }
        break;
      }
    } else {
      graphs = data.columns.reduce((acc, curr) => {        
        if (!acc[curr.header]) acc[curr.header] = [];
        if (curr.info?.newGraph) {
          if ((curr.subHeader === 'Amount Entered') && newAmountEnteredGraph.includes(curr.header)) {
            acc[`${curr.header.split(' ')[0]} ${curr.subHeader}`] = [];
            acc[`${curr.header.split(' ')[0]} ${curr.subHeader}`].push(curr);
          } else {
            acc[curr.subHeader] = [];
            acc[curr.subHeader].push(curr);
          }
          return acc;
        }
        if (curr.info?.hideGraph) return acc;
        acc[curr.header].push(curr);
        return acc;
      }, {});
    }
   
    for (let headerKey in graphs) {
      let eachGraphData: ChartData = {
        header: groupByValue ? headerKey : headerKey + " : " + `${CompareFiltering === 'compare time' ? compareTimeSetGraphHeader() : setGraphHeader()}`,
        data: [],
      };

      
      console.log("Extract Data header Key: ", headerKey, compareTimeSetGraphHeader())
      let subCharts: { [key: string]: Serie } = graphs[headerKey].reduce(
        (acc, curr) => {
          acc[curr.id] = {
            id: t(curr.subHeader),
            data: [],
            key: curr.id,
            total: 0,
            ogId: curr.subHeader
          };
          if (curr.info?.currency) {
            acc[curr.id]["currency"] = curr.info.currency;
          }
          return acc;
        },
        {}
      );

      if (reportViewValue === reportTypes.sorting) {
        for (let row of data.rows) {
          for (let loc of row.location) {
            if(headerKey.includes(loc.locationName)) {
              for (let graph of graphs[headerKey]) {
                subCharts[graph.id].data.push({
                  x: getInsightsDateLabels(row.date, chartTimeFormat),
                  y: loc.data[graph.prevId],
                });
                subCharts[graph.id].total += loc.data[graph.prevId];
              }
            }
          }
        }
      } else {
        for (let row of data.rows) {
          for (let graph of graphs[headerKey]) {
            subCharts[graph.id].data.push({
              x: getInsightsDateLabels(row.date, chartTimeFormat),
              y: row.data[graph.id],
            });
            subCharts[graph.id].total += row.data[graph.id];
          }
        }
      }

      eachGraphData.data = Object.keys(subCharts).map((key) => subCharts[key]);
      graphData.push(eachGraphData);
    }
    console.log('compare type', data);
    return graphData;
  };

  

  function getRandomColor() {
    return '#' + Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, '0');
  }
  
  function mergeSuccessfulData(data1,data2) {
    const finalData = [];
    const output1 = [];
    const output2 = [];
    console.log('data1', selectedReports)
    if(!selectedReports[1]) {
      return data1;
    }
    if(selectedReports[1] === 7) { 
       data2 = data2.filter(item => {
        // Keep only the object with "Totals" in the header
        return item.header.includes('Totals');
    })
    }
    data1.forEach(item1 => {
      item1.data.forEach(item => {
        if(item.id === "Successful" || item.id === "Success" || item.id === "People In" || item.id === "People Out" || item.id === "Detections" || item.id === "Totals" || item.id === "Amount Entered") {
          if(item.id === "People In" || item.id === "People Out" || item.id === "Totals") {
            output1.push({data:[{data:item.data,id:item.id,ogId:item.id,color:getRandomColor(),total:item.total,currency:item?.currency}],header: item1.header});
          } else {
            output1.push({data:[{data:item.data,id:item1.header.split(":")[0],ogId:item1.header.split(":")[0],color:getRandomColor(),total:item.total,currency:item?.currency}],header: item1.header});
          }
        }
      })
    });

    data2.forEach(item2 => {
      item2.data.forEach(item => {
        if(item.id === "Successful" || item.id === "Success" || item.id === "People In" || item.id === "People Out" || item.id === "Detections" || item.id === "Totals" || item.id === "Amount Entered") {
          if(item.id === "People In" || item.id === "People Out" || item.id === "Totals") {
            output2.push({data:[{data:item.data,id:item.id,ogId:item.id,color:getRandomColor(),total:item.total}],header: item2.header});
          } else {
            output2.push({data:[{data:item.data,id:item2.header.split(":")[0],ogId:item2.header.split(":")[0],color:getRandomColor(),total:item.total}],header: item2.header});
          }
        }
      })
    });
    console.log('output1', output1)
    console.log('output2', output2)
    
    if (!output1.length || !output2[0].data) return output1;

    for(let i = 0; i < output1.length; i++) {
      for(let j = 0; j < output2.length; j++) {
        output1[i].header = `Compare By Type: ${output1[i].header.split(":")[1]}`
        output1[i].data.push(...output2[j].data);
      }
    }
    console.log('finalData', output1)
    return output1;
    // return finalData
  };
  
  
  function extractData(data: ReportData, compareType=false) {

    let graphData: ChartData[] = [];
    let graphs: {[key: string]: ReportColumnData[]} = {};

    if (reportViewValue === reportTypes.sorting) {
      for (let row of data.rows) {
        for (let loc of row.location) {
          if (loc?.isAMHLocation) {
            data.columns.map((col) => {
              let newCol = {...col}
              const newHeader = `${loc.locationName}.${col.header}`;
              newCol.prevId = newCol.id;
              newCol.id = newHeader;
              newCol.header = newHeader;
              graphs = {...graphs, [newHeader]: [newCol]};
            });
          }
        }
        break;
      }
    } else {
      graphs = data.columns.reduce((acc, curr) => {        
        if (!acc[curr.header]) acc[curr.header] = [];
        if (curr.info?.newGraph) {
          if ((curr.subHeader === 'Amount Entered') && newAmountEnteredGraph.includes(curr.header)) {
            acc[`${curr.header.split(' ')[0]} ${curr.subHeader}`] = [];
            acc[`${curr.header.split(' ')[0]} ${curr.subHeader}`].push(curr);
          } else {
            acc[curr.subHeader] = [];
            acc[curr.subHeader].push(curr);
          }
          return acc;
        }
        if (curr.info?.hideGraph) return acc;
        acc[curr.header].push(curr);
        return acc;
      }, {});
    }
   
    for (let headerKey in graphs) {
      let eachGraphData: ChartData = {
        header: groupByValue ? headerKey : headerKey + " : " + (CompareFiltering === 'compare time' ? setGraphHeader() + `, ${compareTimeSetGraphHeader()}` : setGraphHeader()),
        data: [],
      };

      
      console.log("Extract Data header Key: ", headerKey, eachGraphData)
      let subCharts: { [key: string]: Serie } = graphs[headerKey].reduce(
        (acc, curr) => {
          acc[curr.id] = {
            id: t(curr.subHeader),
            data: [],
            key: curr.id,
            total: 0,
            ogId: curr.subHeader
          };
          if (curr.info?.currency) {
            acc[curr.id]["currency"] = curr.info.currency;
          }
          return acc;
        },
        {}
      );

      if (reportViewValue === reportTypes.sorting) {
        for (let row of data.rows) {
          for (let loc of row.location) {
            if(headerKey.includes(loc.locationName)) {
              for (let graph of graphs[headerKey]) {
                subCharts[graph.id].data.push({
                  x: getInsightsDateLabels(row.date, chartTimeFormat),
                  y: loc.data[graph.prevId],
                });
                subCharts[graph.id].total += loc.data[graph.prevId];
              }
            }
          }
        }
      } else {
        for (let row of data.rows) {
          for (let graph of graphs[headerKey]) {
            subCharts[graph.id].data.push({
              x: getInsightsDateLabels(row.date, chartTimeFormat),
              y: row.data[graph.id],
            });
            subCharts[graph.id].total += row.data[graph.id];
          }
        }
      }

      eachGraphData.data = Object.keys(subCharts).map((key) => subCharts[key]);
      graphData.push(eachGraphData);
    }
 
    const randomColors = [
      '#2196f3', // blue
      '#ff9800', // orange
      '#4caf50', // green
      '#f44336', // red
      '#9c27b0', // purple
      '#795548', // brown
      '#e91e63', // pink
      '#607d8b', // gray
      '#cddc39', // lime
      '#00bcd4'  // cyan
    ];
    if(CompareFiltering === 'compare location'){
      let compareData = [];
      
      for (let headerKey in graphs) {
        let eachGraphData: ChartData = {
          header: groupByValue ? headerKey : headerKey + " : " + setGraphHeader(),
          data: []
        };

        console.log("Headers under compare location", eachGraphData)

        // Get all unique locations
        const locations = data.rows[0].location.map((loc,index) => ({
          id: loc.locationId,
          name: loc.locationName,
          color: randomColors[index % randomColors.length]
        }));

        // For each location, create a data series
        locations.forEach(location => {
          let locationSeries = {
            id: location.name,
            data: [],
            key: location.id,
            total: 0,
            ogId: location.name,
            color: location.color
          };

          // For each time point, get the location's data
          data.rows.forEach(row => {
            const locationData = row.location.find(loc => loc.locationId === location.id);
            let value = 0;

            // Sum up all "Successful" metrics for this location at this time point
            graphs[headerKey].forEach(metric => {
              if(metric.subHeader === "Successful" || metric.subHeader === "Success" || metric.subHeader === "People In" || metric.subHeader === "People Out" || metric.subHeader === "Detections") {
                value += locationData?.data[metric.id] || 0;
              }
            });

            locationSeries.data.push({
              x: getInsightsDateLabels(row.date, chartTimeFormat),
              y: value
            });

            locationSeries.total += value;
          });

          eachGraphData.data.push(locationSeries);
        });

        compareData.push(eachGraphData);
      }
      console.log(compareData)
      return compareData;
    } else if(CompareFiltering === 'compare device'){
      let compareData = [];
      
      // Define a color palette for devices
      // const deviceColors = [
      //   '#2196f3', // blue
      //   '#ff9800', // orange
      //   '#4caf50', // green
      //   '#f44336', // red
      //   '#9c27b0', // purple
      //   '#795548', // brown
      //   '#e91e63', // pink
      //   '#607d8b', // gray
      //   '#cddc39', // lime
      //   '#00bcd4'  // cyan
      // ];
      
      for (let headerKey in graphs) {
        let eachGraphData: ChartData = {
          header: groupByValue ? headerKey : headerKey + " : " + setGraphHeader(),
          data: []
        };

        console.log("Headers under compare device", eachGraphData)
    
        // Get all unique devices from all locations
        const devices = new Map();
        data.rows[0].location.forEach(loc => {
          loc.device.forEach((device, index) => {
            if (!devices.has(device.deviceId)) {
              devices.set(device.deviceId, {
                id: device.deviceId,
                name: device.deviceName,
                color: randomColors[devices.size % randomColors.length]
              });
            }
          });
        });
    
        // For each device, create a data series
        devices.forEach(device => {
          let deviceSeries = {
            id: device.name,
            data: [],
            key: device.id,
            total: 0,
            ogId: device.name,
            color: device.color
          };
    
          // For each time point, get the device's data
          data.rows.forEach(row => {
            let value = 0;
    
            // Sum up all "Successful" metrics for this device at this time point
            row.location.forEach(loc => {
              const deviceData = loc.device.find(dev => dev.deviceId === device.id);
              if (deviceData) {
                graphs[headerKey].forEach(metric => {
                  if(metric.subHeader === "Successful" || metric.subHeader === "Success" || metric.subHeader === "People In" || metric.subHeader === "People Out" || metric.subHeader === "Detections") {
                    value += deviceData.data[metric.id] || 0;
                  }
                });
              }
            });
    
            deviceSeries.data.push({
              x: getInsightsDateLabels(row.date, chartTimeFormat),
              y: value
            });
    
            deviceSeries.total += value;
          });
    
          eachGraphData.data.push(deviceSeries);
        });
    
        compareData.push(eachGraphData);
      }
    
      return compareData;
    } else if(CompareFiltering === 'compare type'){
      // console.log('compare type_1 ', graphData)
      const comdata = processCompareTypeData(data.compare)
      // console.log('compare type_2', comdata)
      const mergedData = mergeSuccessfulData(graphData,comdata)
      // console.log('mergedData', mergedData)
      // return ;
      // setCompareMainReports(graphData)
      return mergedData
    } else if(CompareFiltering === 'compare time'){
      const comdata = processCompareTypeData(data.compare)
      console.log('compare time',selectedTimeFrames)
      console.log('compare time',comdata)
      console.log('compare time',graphData)
      
      // Process compare time data
      if (comdata && selectedTimeFrames && selectedTimeFrames.length >= 2) {
        // Define colors for different timeframes
        const timeframeColors = {
          [selectedTimeFrames[0]]: '#2196f3', // blue for main timeframe
          [selectedTimeFrames[1]]: '#ff9800'  // orange for compare timeframe
        };
        
        // Process main data to use first timeframe name
        const processedMainData = graphData.map(section => {
          const successfulData = section.data.filter(item => 
            item.id === "Successful" || item.id === "Success" || item.id === "People In" || 
            item.id === "People Out" || item.id === "Detections" || item.id === "Totals" || 
            item.id === "Amount Entered"
          );
          
          const updatedData = successfulData.map(item => {
            // Special handling for People In and People Out
            if (item.id === "People In" || item.id === "People Out") {
              return {
                ...item,
                id: `${item.id} ${selectedTimeFrames[0]}`, // People In + timeframe
                ogId: `${item.id} ${selectedTimeFrames[0]}`,
                color: getRandomColor()
              };
            } else {
              return {
                ...item,
                id: selectedTimeFrames[0], // Use first timeframe as main
                ogId: selectedTimeFrames[0],
                color: getRandomColor()
              };
            }
          });
          
          return {
            ...section,
            data: updatedData
          };
        });
        
        // Process compare data and normalize X values to match main data
        const normalizedCompareData = processedMainData.map((mainSection, index) => {
          const compareSection = comdata[index];
          if (!compareSection) return mainSection;
          
          const successfulData = compareSection.data.filter(item => 
            item.id === "Successful" || item.id === "Success" || item.id === "People In" || 
            item.id === "People Out" || item.id === "Detections" || item.id === "Totals" || 
            item.id === "Amount Entered"
          );
          
          // Get the main data's X values for alignment
          const mainDataItem = mainSection.data.find(item => 
            item.id === selectedTimeFrames[0] || 
            item.id === `People In ${selectedTimeFrames[0]}` || 
            item.id === `People Out ${selectedTimeFrames[0]}`
          );
          const mainXValues = mainDataItem ? mainDataItem.data.map(point => point.x) : [];
          
          // Create normalized compare data with same X values as main data
          const normalizedCompareData = successfulData.map(item => {
            const normalizedData = mainXValues.map((xValue, xIndex) => {
              const comparePoint = item.data[xIndex];
              return {
                x: xValue, // Use main data's X value
                y: comparePoint ? comparePoint.y : 0 // Use compare data's Y value, or 0 if not available
              };
            });
            
            // Special handling for People In and People Out in compare data
            if (item.id === "People In" || item.id === "People Out") {
              return {
                ...item,
                id: `${item.id} ${selectedTimeFrames[1]}`, // People In + timeframe
                ogId: `${item.id} ${selectedTimeFrames[1]}`,
                color: getRandomColor(),
                data: normalizedData
              };
            } else {
              return {
                ...item,
                id: selectedTimeFrames[1], // Use second timeframe as compare
                ogId: selectedTimeFrames[1],
                color: getRandomColor(),
                data: normalizedData
              };
            }
          });
          
          return {
            ...mainSection,
            data: [...mainSection.data, ...normalizedCompareData]
          };
        });
        console.log("normalizedCompareData", normalizedCompareData)
        return normalizedCompareData;
      }
     
    }
    return graphData;
  }

  const formatDateRange = (startPage: string, endPage: string, interval: string) => {
    console.log("startPage", startPage, "endPage", endPage, "interval", interval)
    if (groupByValue) {
      return "";
    }
    switch (interval) {
      case "hour":
        return getFormattedDate(startPage, "Do MMMM YYYY");
      case "day":
        if (
          getFormattedDate(startPage, "YYYY") !==
          getFormattedDate(endPage, "YYYY")
        ) {
          return (
            getFormattedDate(startPage, "MMMM YYYY") +
            " - " +
            getFormattedDate(endPage, "MMMM YYYY")
          );
        } else if (
          getFormattedDate(startPage, "MMMM") !==
          getFormattedDate(endPage, "MMMM")
        ) {
          return (
            getFormattedDate(startPage, "MMMM") +
            " - " +
            getFormattedDate(endPage, "MMMM YYYY")
          );
        } else if (
          getFormattedDate(startPage, "D") == getFormattedDate(endPage, "D")
        ) {
          return getFormattedDate(startPage, "Do MMMM YYYY");
        }
        return (
          getFormattedDate(startPage, "Do") +
          " - " +
          getFormattedDate(endPage, "Do MMMM YYYY")
        );
      case "month":
        if (
          getFormattedDate(startPage, "YYYY") !==
          getFormattedDate(endPage, "YYYY")
        ) {
          return (
            getFormattedDate(startPage, "MMMM YYYY") +
            " - " +
            getFormattedDate(endPage, "MMMM YYYY")
          );
        } else if (
          getFormattedDate(startPage, "MMMM") !==
          getFormattedDate(endPage, "MMMM")
        ) {
          return (
            getFormattedDate(startPage, "MMMM") +
            " - " +
            getFormattedDate(endPage, "MMMM YYYY")
          );
        }
        return getFormattedDate(startPage, "MMMM YYYY");
      default:
        return "";
    }
  };

  function extractCompareReportData(data: ReportData, compareType=false, ComparestartPage: string, CompareendEndPage: string, compareInterval: string) {
    // Create a deep copy of data to avoid modifying the original
    const dataCopy = JSON.parse(JSON.stringify(data));
    
    // Override the interval if provided
    if (compareInterval) {
      console.log("Using compareInterval:", compareInterval);
      dataCopy.interval = compareInterval;
    }
    
    let graphData: ChartData[] = [];
    let graphs: {[key: string]: ReportColumnData[]} = {};

    if (reportViewValue === reportTypes.sorting) {
      for (let row of dataCopy.rows) {
        for (let loc of row.location) {
          if (loc?.isAMHLocation) {
            dataCopy.columns.map((col) => {
              let newCol = {...col}
              const newHeader = `${loc.locationName}.${col.header}`;
              newCol.prevId = newCol.id;
              newCol.id = newHeader;
              newCol.header = newHeader;
              graphs = {...graphs, [newHeader]: [newCol]};
            });
          }
        }
        break;
      }
    } else {
      graphs = dataCopy.columns.reduce((acc, curr) => {        
        if (!acc[curr.header]) acc[curr.header] = [];
        if (curr.info?.newGraph) {
          if ((curr.subHeader === 'Amount Entered') && newAmountEnteredGraph.includes(curr.header)) {
            acc[`${curr.header.split(' ')[0]} ${curr.subHeader}`] = [];
            acc[`${curr.header.split(' ')[0]} ${curr.subHeader}`].push(curr);
          } else {
            acc[curr.subHeader] = [];
            acc[curr.subHeader].push(curr);
          }
          return acc;
        }
        if (curr.info?.hideGraph) return acc;
        acc[curr.header].push(curr);
        return acc;
      }, {});
    }
   
    for (let headerKey in graphs) {
      console.log("Using interval for header:", dataCopy.interval);
      let eachGraphData: ChartData = {
        header: groupByValue ? headerKey : headerKey + " : " + formatDateRange(ComparestartPage, CompareendEndPage, dataCopy.interval),
        data: [],
      };

      console.log("Headers under extract Compare ReportData", eachGraphData);

      let subCharts: { [key: string]: Serie } = graphs[headerKey].reduce(
        (acc, curr) => {
          acc[curr.id] = {
            id: t(curr.subHeader),
            data: [],
            key: curr.id,
            total: 0,
            ogId: curr.subHeader
          };
          if (curr.info?.currency) {
            acc[curr.id]["currency"] = curr.info.currency;
          }
          return acc;
        },
        {}
      );

      if (reportViewValue === reportTypes.sorting) {
        for (let row of dataCopy.rows) {
          for (let loc of row.location) {
            if(headerKey.includes(loc.locationName)) {
              for (let graph of graphs[headerKey]) {
                subCharts[graph.id].data.push({
                  x: getInsightsDateLabels(row.date, chartTimeFormat),
                  y: loc.data[graph.prevId],
                });
                subCharts[graph.id].total += loc.data[graph.prevId];
              }
            }
          }
        }
      } else {
        for (let row of dataCopy.rows) {
          for (let graph of graphs[headerKey]) {
            subCharts[graph.id].data.push({
              x: getInsightsDateLabels(row.date, chartTimeFormat),
              y: row.data[graph.id],
            });
            subCharts[graph.id].total += row.data[graph.id];
          }
        }
      }

      eachGraphData.data = Object.keys(subCharts).map((key) => subCharts[key]);
      graphData.push(eachGraphData);
    }

    const randomColors = [
      '#2196f3', // blue
      '#ff9800', // orange
      '#4caf50', // green
      '#f44336', // red
      '#9c27b0', // purple
      '#795548', // brown
      '#e91e63', // pink
      '#607d8b', // gray
      '#cddc39', // lime
      '#00bcd4'  // cyan
    ];
    
    return graphData;
  }
  const onChangeReport = () => {
    setFormat(formatLookup[getTickInterval()]);
    
    // // Only update chart data if not in a comparison mode
    // if (CompareFiltering == 'compare time' || CompareFiltering == 'compare type') {
    //   //setCompareReportsLoading(true);
    //    return ;
    //   //setCompareReportsLoading(false);
    // }
    setChartData(getGraphData());
    // Don't call setChartData here for comparison modes
  };

  const onDateChange = (values: any) => {
    setStartTime(values.startTime);
    setEndTime(values.endTime);
  };

  const updatePageInfo = (values: any) => {
    console.log("updatePageInfo", values)
    setStartPage(values.startPage);
    setEndPage(values.endPage);
    setStartDateTime(values.startDateTime);
    setEndDateTime(values.endDateTime);
    setSelectedFrequency(values?.selectedFrequency);
  };

  const updateCompareInfo = (values: any) => {
    console.log("updateCompareInfo", values)
    setCompareStartDateTime(values.compareStartDateTime);
    setCompareEndDateTime(values.compareEndDateTime);
    setCompareFrequency(values.compareFrequency);
    setCompareGroupByValue(values.compareGroupByValue);
  }

  const onPageChange = (page: any) => {
    setCurrentPage(page);
    setPageChanged(true);
  };

  useEffect(() => {
    if (prevReport) {
      reportValues.startTime && setStartTime(reportValues.startTime);
      reportValues.endTime && setEndTime(reportValues.endTime);
    }
  }, [prevReport]);

  // // Function to get translated full day name (e.g. Monday)
  // const getTranslatedFullDayName = (date: string) => {
  //   const day = moment(date).format('dddd');
  //   return t(day);
  // };

  // // Function to get translated abbreviated day name (e.g. Mon) 
  // const getTranslatedShortDayName = (date: string) => {
  //   const day = moment(date).format('ddd');
  //   return t(day);
  // };

  // // Function to get translated full month name (e.g. January)
  // const getTranslatedFullMonthName = (date: string) => {
  //   const month = moment(date).format('MMMM');
  //   return t(month);
  // };

  // // Function to get translated abbreviated month name (e.g. Jan)
  // const getTranslatedShortMonthName = (date: string) => {
  //   const month = moment(date).format('MMM');
  //   return t(month);
  // };

  // format lookup for various interval
  const formatLookup = {
    hour: {
      x: {
        format: "time:%H:%M",
        scale: {
          precision: "minute",
          format: "%H:%M ",
          tickValue: "every hour",
          min: startTime
            ? moment(startPage).startOf("h").format(chartTimeFormat)
            : moment(startPage).startOf("day").format(chartTimeFormat),
          max: endTime
            ? moment(endPage).endOf("h").format(chartTimeFormat)
            : moment(endPage).endOf("day").format(chartTimeFormat),
        },
      },
      y: {},
    },
    "3 hours": {
      x: {
        format: "time:%H:%M",
        scale: {
          precision: "minute",
          format: "%H:%M ",
          tickValue: "every 3 hours",
          min: startTime
            ? moment(startPage).format(chartTimeFormat)
            : moment(startPage).startOf("day").format(chartTimeFormat),
          max: endTime
            ? moment(endPage).format(chartTimeFormat)
            : moment(endPage).endOf("day").format(chartTimeFormat),
        },
      },
      y: {},
    },
    day: {
      x: {
        format: "time:%d %b",
        scale: {
          precision: "day",
          format: "%A",
          tickValue: "every day", 
          min: moment(startPage).startOf("day").format(chartTimeFormat),
          max: moment(endPage).endOf("day").format(chartTimeFormat),
        },
      },
      y: {},
    },
    "3 days": {
      x: {
        format: "time:%e %b",
        scale: {
          precision: "day",
          format: "%d",
          tickValue: "every 3 days",
          min: moment(startPage).startOf("month").format(chartTimeFormat),
          max: moment(endPage).endOf("month").format(chartTimeFormat),
        },
      },
      y: {},
    },
    month: {
      x: {
        format: "time:%B",
        scale: {
          precision: "month",
          format: "%b",
          tickValue: "every month",
          min: moment(startPage).startOf("year").format(chartTimeFormat),
          max: moment(endPage).endOf("year").format(chartTimeFormat),
        },
      },
      y: {},
    },
  };

  const insightHeaderResized = (height: number) => {
    setInsightHeaderHeight(height);
  };


  const exportGraph = (csvFileName : string) => {
    setDownloadingGraph(true);
    AppService.showToast(t(jsonData.ExportPdfAlertMessage))
    setTimeout(() => {
      graphRef.current.callChildFunction(csvFileName);
    }, 10);
  }

  const defaultFiltering = (value) => {
    setCompareFiltering(value)
    
  }

  const selectedCompareReports = (value,mainGraphDataId,SecondaryGraphDataId,startDate,enddate,intervalValue) => {
    setCompareReportsLoading(true)
    // Define random colors array
    const randomColors = [
        '#2196f3', // blue
        '#ff9800', // orange
        '#4caf50', // green
        '#f44336', // red
        '#9c27b0', // purple
        '#795548', // brown
        '#e91e63', // pink
        '#607d8b', // gray
        '#cddc39', // lime
        '#00bcd4'  // cyan
    ];

    // Get the processed data
    // console.log(extractCompareReportData(value[0]), extractCompareReportData(value[1]))
    // setTimeout(() => {
      
    // })
    const data = processGraphData(extractCompareReportData(value[0],false,startDate,enddate,intervalValue), extractCompareReportData(value[1],false,startDate,enddate,intervalValue),mainGraphDataId,SecondaryGraphDataId);

    // Create a map to track used colors for each unique metric
    const metricColorMap = new Map();
    let colorIndex = 0;

    // Update colors in the processed data
    data.forEach(section => {
        section.data.forEach(item => {
            // Use the same color for the same metric across different sections
            if (!metricColorMap.has(item.id)) {
                metricColorMap.set(item.id, randomColors[colorIndex % randomColors.length]);
                colorIndex++;
            }
            item.color = metricColorMap.get(item.id);

            // Also update color in the data points if needed
            if (Array.isArray(item.data)) {
                item.data.forEach(dataPoint => {
                    dataPoint.color = item.color;
                });
            }
        });
    });

    console.log('compare data with updated colors', data);
    setChartData(data);
    setCompareReportsLoading(false)
  };



  return (
    <>
      <div className="pl-vw insightHeaderDiv">
        <Row id="1">
          <InsightHeader
            onChangeReport={onChangeReport}
            onDateChange={onDateChange}
            activeRepresentation={activeRepresentation}
            setActiveRepresentation={setActiveRepresentation}
            onInsightHeaderResize={insightHeaderResized}
            groupByValue={groupByValue}
            setGroupByValue={setGroupByValue}
            setShowLoading={setShowLoading}
            updatePageInfo={updatePageInfo}
            updateCompareInfo={updateCompareInfo}
            pageChanged={pageChanged}
            setPageChanged={setPageChanged}
            onPageChange={onPageChange}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pages={pages}
            setPages={setPages}
            setExportData={setExportData}
            breakFrom={breakFrom}
            breakTo={breakTo}
            setBreakFrom={setBreakFrom}
            setBreakTo={setBreakTo}
            selectedLocations={locations}
            setSelectedLocations={setLocations}
            selectedDevices={devices}
            setSelectedDevices={setDevices}
            viewInsight={location?.state?.Viewable ?? false}
            onlyCloudCheck={onlyCloudCheck}
            setOnlyCloudCheck={setOnlyCloudCheck}
            insighthasData={insighthasData}
            setInisghtReportValue={setInisghtReportValue}
            setReportViewValue={setReportViewValue}
            exportGraph={exportGraph}
            downloadingGraph={downloadingGraph}
            reportViewValue={reportViewValue}
            CompareFiltering={defaultFiltering}
            selectedReports={selectedReports}
            selectedCompareReports={selectedCompareReports}
            selectedTimeFrames={selectedTimeFrames}
            setCompareMultipleReports={setSelectedMultipleReports}
            setCompareReportsLoading={setCompareReportsLoading}
            setSelectedTimeFrames={setSelectedTimeFrames}
          />
        </Row>
      </div>
      {/* chartData={translateGraphText(chartData,t,'header','id')} */}
      <ReportScreen>
        {activeRepresentation === InsightRepresentation.GRAPHICAL ? (
          <>
          <InsightGraph
            graphType={reportViewValue === reportTypes.sorting ? reportTypes.sorting : ""}
            chartData={chartData}
            colorKeys={getCoumnsKeys(reportData)}
            pieChartData={convertForGraphData(reportData?.rows)}
            groupByValue={groupByValue}
            format={format}
            startPage={startPage}
            endPage={endPage}
            pages={pages}
            onlyCloudCheck={onlyCloudCheck}
            selectedDevices={devices}
            setInsightHasData={setInsightHasData}
            ref={graphRef}
            setDownloadingGraph={setDownloadingGraph}
            CompareFiltering={CompareFiltering}
            compareReportsLoading = {compareReportsLoading}
            />
          </>
        ) : (
          (reportViewValue === reportTypes.paymentDetails ?
            <PaymentDetailTable
              showLoading={showLoading}
              groupByValue={groupByValue}
              insightHeaderHeight={insightHeaderHeight}
              startPage={startPage}
              endPage={endPage}
              pages={pages}
              exportData={exportData}
              setExportData={setExportData}
              setBreakFrom={setBreakFrom}
              setBreakTo={setBreakTo}
              selectedLocations={locations}
              selectedDevices={devices}
              getInsightsDateLabels={getInsightsDateLabels}
              onlyCloudCheck={onlyCloudCheck}
              setInsightHasData={setInsightHasData}
              inisghtReportValue={inisghtReportValue}
            />
          :
            <InsightTable
              showLoading={showLoading}
              groupByValue={groupByValue}
              insightHeaderHeight={insightHeaderHeight}
              startPage={startPage}
              endPage={endPage}
              pages={pages}
              exportData={exportData}
              setExportData={setExportData}
              setBreakFrom={setBreakFrom}
              setBreakTo={setBreakTo}
              selectedLocations={locations}
              selectedDevices={devices}
              getInsightsDateLabels={getInsightsDateLabels}
              onlyCloudCheck={onlyCloudCheck}
              setInsightHasData={setInsightHasData}
              inisghtReportValue={inisghtReportValue}
            />
          )
        )}
        {!reportDataFormState?.loading &&
          !formState?.loading &&
          !showLoading &&
          pages * 10 > 10 &&
          !groupByValue && (
            <AntdPagination
              className="insight-pagination"
              total={pages * 10}
              current={currentPage}
              defaultPageSize={10}
              onChange={(page: any, pageSize: any) => onPageChange(page)}
            />
          )}
        {
          !reportDataFormState?.loading && !formState?.loading  && !showLoading && !insighthasData ?
            <div className="MessageInisght">
              {t(jsonData.NoInsight)}
            </div>
            : null}
      </ReportScreen>
    </>
  );
};

export default Insights;
